// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"678":"7672f20a93a81be1afa2","731":"7e6c68fdb3e1a95c886f","843":"e50f0069c30bd5bf7151","883":"f982e1a936a99d3f328c"}[chunkId] + ".js";
};